import {Configurations} from '@domain/model/Config/Configurations';
import {Configuration} from '@domain/model/Config/Configuration';

export const RetrieveConfiguration =
  (repo: Configurations): (() => Configuration) =>
  () => {
    return repo.retrieve();
  };
